var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7280_38798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6675 6.49762C22.113 5.4233 21.3862 4.41492 20.4856 3.51436C19.585 2.61375 18.5766 1.88695 17.5023 1.33252L9.04847 9.04842L1.33252 17.5023C1.887 18.5766 2.6138 19.585 3.51436 20.4856C4.41493 21.3862 5.42335 22.113 6.49763 22.6674L14.9515 14.9515L22.6675 6.49762Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51443 20.4856C4.01782 20.989 4.55496 21.438 5.11835 21.8333L21.8332 5.11833C21.438 4.55494 20.9891 4.0178 20.4857 3.51441C19.9822 3.01102 19.4451 2.56209 18.8817 2.16684L2.16687 18.8817C2.56207 19.445 3.011 19.9823 3.51443 20.4856Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51429 3.51439C-0.271664 7.30034 -0.99846 12.9862 1.33245 17.5024L17.5023 1.33259C12.986 -0.998271 7.3002 -0.27138 3.51429 3.51439Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4856 20.4856C24.2715 16.6997 24.9983 11.0139 22.6675 6.49772L6.49768 22.6675C11.0139 24.9983 16.6997 24.2716 20.4856 20.4856Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39498 3.6518L7.04251 5.64478H9.13801L7.44273 6.87647L8.09026 8.86941L6.39498 7.63767L4.69961 8.86941L5.34723 6.87647L3.65186 5.64478H5.74736L6.39498 3.6518Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7280_38798"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/cd.00450596025f48b091d2f9ff1ff2c303.svg";
export { ForwardRef as ReactComponent };